import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {
  @Input() name!: string;
  @Input() image!: string;
  @Input() size: 'sm' | 'md' | 'lg' | 'xxl' = 'sm';

  showInitials!: boolean;
  initials!: string;

  ngOnInit() {
    this.generateInitials();
  }

  generateInitials() {
    if (this.name) {
      const words = this.name.trim().split(' ');
      this.initials =
        words.length > 1
          ? (words[0][0] + words[1][0]).toUpperCase()
          : words[0][0].toUpperCase();
    }
  }

  handleImageError() {
    this.showInitials = true;
  }
}
